import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { getApiData } from "../helpers/AxiosInstance";

interface IUseGetHook {
  queryKey: string[];
  url: string;
  params: any;
  interval?: number;
  enabled?: boolean; // <-- add this
}

const useGetHook = (props: IUseGetHook) => {
  const { queryKey, url, params, interval, enabled = true } = props;

  const { isLoading, isError, data, isSuccess, refetch, isRefetching } =
    useQuery({
      queryKey: queryKey,
      queryFn: async () => {
        const response = await getApiData(url, params);
        return response.data;
      },
      refetchOnWindowFocus: true,
      refetchInterval: interval ?? false,
      placeholderData: keepPreviousData,
      enabled,
    });

  return { isLoading, isError, data, isSuccess, refetch, isRefetching };
};

export default useGetHook;
